import apiClient from '../api';
import { DailyMetrics } from '../../types';

export const metricsService = {
  // Get all metrics with optional filters (supports viewAs for coach read-only access)
  getMetrics: async (
    startDate?: string,
    endDate?: string,
    showId?: string,
    viewAs?: string,
  ): Promise<DailyMetrics[]> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate)   params.append('endDate', endDate);
    if (showId)    params.append('showId', showId);
    if (viewAs)    params.append('viewAs', viewAs);

    const response = await apiClient.get(`/metrics?${params.toString()}`);
    return response.data;
  },

  // Get metrics for specific date (supports viewAs for coach read-only access)
  getMetricsByDate: async (date: string, viewAs?: string): Promise<DailyMetrics> => {
    const params = viewAs ? `?viewAs=${viewAs}` : '';
    const response = await apiClient.get(`/metrics/date/${date}${params}`);
    return response.data;
  },

  // Get latest metrics (supports viewAs for coach read-only access)
  getLatestMetrics: async (viewAs?: string): Promise<DailyMetrics> => {
    const params = viewAs ? `?viewAs=${viewAs}` : '';
    const response = await apiClient.get(`/metrics/latest${params}`);
    return response.data;
  },

  // Create new metrics
  createMetrics: async (metrics: Partial<DailyMetrics>): Promise<DailyMetrics> => {
    const response = await apiClient.post('/metrics', metrics);
    return response.data;
  },

  // Update metrics
  updateMetrics: async (id: string, metrics: Partial<DailyMetrics>): Promise<void> => {
    await apiClient.put(`/metrics/${id}`, metrics);
  },

  // Delete metrics
  deleteMetrics: async (id: string): Promise<void> => {
    await apiClient.delete(`/metrics/${id}`);
  },

  // Get summary/trends
  getMetricsSummary: async (days: number = 30): Promise<any> => {
    const response = await apiClient.get(`/metrics/summary?days=${days}`);
    return response.data;
  },

  // Save metrics (create or update based on existence)
  saveMetrics: async (metrics: Partial<DailyMetrics>): Promise<DailyMetrics> => {
    if (metrics.metricId) {
      await apiClient.put(`/metrics/${metrics.metricId}`, metrics);
      return metrics as DailyMetrics;
    } else {
      const response = await apiClient.post('/metrics', metrics);
      return response.data;
    }
  },
};
